/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_CatalanInputs */

const en_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalan`)
};

const fr_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalan`)
};

const de_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`katalanisch`)
};

const it_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`catalano`)
};

const ru_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`каталанский`)
};

const es_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`catalán`)
};

const zh_cn2_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加泰罗尼亚语`)
};

const ja_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カタルーニャ語`)
};

const hi_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कातालान`)
};

const pt_pt2_speechmatics_target_language_catalan = /** @type {(inputs: Speechmatics_Target_Language_CatalanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`catalão`)
};

/**
* | output |
* | --- |
* | "Catalan" |
*
* @param {Speechmatics_Target_Language_CatalanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_catalan = /** @type {((inputs?: Speechmatics_Target_Language_CatalanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_CatalanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_catalan(inputs)
	if (locale === "de") return de_speechmatics_target_language_catalan(inputs)
	if (locale === "it") return it_speechmatics_target_language_catalan(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_catalan(inputs)
	if (locale === "es") return es_speechmatics_target_language_catalan(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_catalan(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_catalan(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_catalan(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_catalan(inputs)
	return en_speechmatics_target_language_catalan(inputs)
});